import React from "react";
import UploadIcon from "../../svgs/upload-file.svg";
import DownloadIcon from "../../svgs/download-file.svg";
import Document from "../../svgs/sheet-upload.svg";
import CloseIcon from "@mui/icons-material/Close";

const DocumentUpload = ({
  attachment,
  handleAttachmentChange,
  uploadTitle = "Upload Attachment",
  downloadTitle = "Download Attachment",
  allowedFileTypes = ".pdf,.doc,.docx,.xls,.xlsx",
  downloadMode = false,
  disabled = false,
  documentIcon = Document,
  setAttachment = null,
}) => {
  const handleDownload = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (attachment) {
      if (typeof attachment === "string") {
        window.open(attachment, "_blank");
      } else if (attachment instanceof File) {
        const url = URL.createObjectURL(attachment);
        const link = document.createElement("a");
        link.href = url;
        link.download = attachment.name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    }
  };

  const handleUploadClick = () => {
    if (!downloadMode && !disabled && !attachment) {
      document.getElementById("document-upload").click();
    }
  };

  const handleDeleteFile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (setAttachment && !disabled && attachment) {
      setAttachment(null);
    }
  };

  return (
    <div className="upload-box">
      <div
        className="upload-box-inner"
        onClick={
          downloadMode || attachment ? handleDownload : handleUploadClick
        }
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      >
        <img src={documentIcon} alt="Upload" className="upload-img" />

        {downloadMode || attachment ? (
          <div className="upload-text-box">
            <img src={DownloadIcon} alt="Download" />
            <span className="upload-text">{downloadTitle}</span>
          </div>
        ) : (
          <div className="upload-text-box">
            <img src={UploadIcon} alt="Upload" />
            <span className="upload-text">{uploadTitle}</span>
          </div>
        )}
      </div>

      <input
        type="file"
        accept={allowedFileTypes}
        onChange={handleAttachmentChange}
        style={{ display: "none" }}
        id="document-upload"
        disabled={disabled}
      />

      {attachment && setAttachment && (
        <div className="uploaded-file-info">
          <div className="file-info-container">
            <span className="file-name">
              {attachment.name || "File uploaded"}
            </span>
            <button
              type="button"
              className="delete-file-btn"
              onClick={handleDeleteFile}
              disabled={disabled}
              title="Remove file"
            >
              <CloseIcon
                style={{ color: "#FF0000", height: "14px", width: "14px" }}
              />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentUpload;
